import Box from '@mui/material/Box';

import { Footer } from '../../components/layout/Footer';
import { LegalDisclaimer } from '../../components/layout/LegalDisclaimer';
import { TopNav } from '../../components/layout/TopNav';

import { Carousel } from './components/Carousel';
import { Hero } from './components/Hero';
import { Madlib } from './components/Madlib';
import { Resources } from './components/Resources';
import { SearchBar } from './components/SearchBar';
import { landingPageStyles as styles } from './LandingPage.styles';

/**
 * Marketing landing page.
 * Figma: 58:39161 — section order preserved; layout is responsive.
 */
export function LandingPage() {
  return (
    <Box sx={styles.root}>
      <TopNav />
      <Box component="main" sx={styles.main}>
        <Box sx={styles.heroBand}>
          <Hero />
          <SearchBar />
        </Box>
        <Carousel />
        <Madlib />
        <Resources />
      </Box>
      <Footer />
      <LegalDisclaimer />
    </Box>
  );
}
